import { object, literal, union } from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

// For tours to work multiple parties need to be presents/synced on the page
export let Party;
(function (Party) {
  Party["UNIFIED_NAVIGATION_UI"] = "unified-navigation-ui";
  Party["NAV_ONBOARDING_TOURS_CONSUMER"] = "nav-onboarding-tours-consumer";
  Party["APP_STARTING_TOUR"] = "app-starting-tour";
})(Party || (Party = {}));
const partySchema = union(literal(Party.UNIFIED_NAVIGATION_UI), literal(Party.NAV_ONBOARDING_TOURS_CONSUMER), literal(Party.APP_STARTING_TOUR));
const partyAck = defineMessage({
  type: 'partyAck',
  payloadSchema: object({
    party: partySchema
  })
});
const partyAlive = defineMessage({
  type: 'partyAlive',
  payloadSchema: object({
    party: partySchema
  }),
  reply: partyAck
});
export const syncMessages = {
  partyAlive,
  partyAck
};